import { FaGithub } from "react-icons/fa";

export default function GithubIcon({ size }) {
    return <FaGithub size={size} />;
}